export const CREATE_WAREHOUSE = 'CREATE_WAREHOUSE';
export const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE';
export const GET_ALL_WAREHOUSE = 'GET_ALL_WAREHOUSE';
export const GET_ID_WAREHOUSE = 'GET_ID_WAREHOUSE';
export const SEARCH_WAREHOUSE = 'SEARCH_WAREHOUSE';
export const UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE';
export const ASSIGN_USERS_WAREHOUSE = 'ASSIGN_USERS_WAREHOUSE';
export const DELETE_USERS_WAREHOUSE = 'DELETE_USERS_WAREHOUSE';
export const GET_WAREHOUSE_USERS = 'GET_WAREHOUSE_USERS';
export const GET_WAREHOUSE_UNASSIGNED_USERS = 'GET_WAREHOUSE_UNASSIGNED_USERS';

export const WAREHOUSE_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    MAINTENANCE: 'maintenance'
};
